import {SODeleteRequirement} from '../../core/requirement/so-delete-requirement';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteRequirement extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteRequirement;
}